import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';

const TYPE_LABELS = {
  update: { label: 'Güncelleme', badge: 'badge-primary', icon: '🚀' },
  announcement: { label: 'Duyuru', badge: 'badge-warning', icon: '📢' }
};

function Announcements() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchAnnouncements(); }, []);

  const fetchAnnouncements = async () => {
    try {
      const token = localStorage.getItem('crm_token');
      const { data } = await axios.get('/api/announcements', { headers: { Authorization: `Bearer ${token}` } });
      setItems(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Fetch announcements error:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading"><div className="loading-spinner"></div></div>;

  return (
    <div>
      <div className="header">
        <div>
          <h1 className="page-title">Güncellemeler</h1>
          <p className="page-subtitle">CRM'e eklenen yeni özellikler ve duyurular burada listelenir.</p>
        </div>
      </div>

      {items.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">📣</div>
          <div className="empty-state-title">Henüz bir güncelleme veya duyuru yok</div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {items.map(item => {
            const t = TYPE_LABELS[item.type] || TYPE_LABELS.update;
            return (
              <div key={item.id} className="card">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ fontSize: 20 }}>{t.icon}</span>
                    <h3 style={{ fontSize: '1.05rem', fontWeight: 700, margin: 0 }}>{item.title}</h3>
                    <span className={`badge ${t.badge}`}>{t.label}</span>
                  </div>
                  <span className="text-muted" style={{ fontSize: 12 }}>
                    {format(new Date(item.created_at), 'd MMMM yyyy, HH:mm', { locale: tr })}
                  </span>
                </div>
                <p style={{ marginTop: 10, marginBottom: 0, whiteSpace: 'pre-wrap', lineHeight: 1.6, color: 'var(--text-secondary)' }}>
                  {item.content}
                </p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default Announcements;
